import { KeyboardArrowDown } from "@mui/icons-material";
import { useEffect, useState } from "react";

import useService from "../../../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../../../global/ApiRequestErrorHandler";
import ResponseModal from "../../../../../global/ResponseModal";
import { PAYMENTS_MODAL_STYLES } from "../../../../../modules/payments/styles/styles";
import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../ui library/HNSColors";

export default function ProviderSettlementStatusSelect({
  detail,
  options,
  disabled,
}) {
  const providerSettlementRepository = useService(
    "repositories/provider-settlement-repository"
  );
  const [status, setStatus] = useState(detail?.status ?? "");
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setStatus(detail?.status ?? "");
  }, [detail?.status]);

  const dropdownOptions = [
    { id: "", label: "Unset" },
    ...options.map(([value, label]) => ({ id: value, label })),
  ];
  const selectedOption = dropdownOptions.find((option) => option.id === status) ?? null;

  const handleChange = async (nextStatus) => {
    const previousStatus = status;

    setStatus(nextStatus);
    setIsSaving(true);

    try {
      await providerSettlementRepository.patch(detail.pk, {
        status: nextStatus || null,
      });
    } catch (error) {
      setStatus(previousStatus);
      setErrorMessage(ApiRequestErrorHandler(error?.response?.data));
      setShowError(true);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <AutoCompleteDropdown
        data={dropdownOptions}
        initValue={selectedOption}
        className="w-full pr-2"
        size="small"
        disabled={disabled || isSaving}
        popupIcon={
          <KeyboardArrowDown
            sx={{ fontSize: 22, color: HNSColors.primary[500], marginRight: "4px" }}
          />
        }
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        onValueChange={(_, value) => handleChange(value?.id ?? "")}
        textFieldSx={{
          ...PAYMENTS_MODAL_STYLES.textField,
          "& .MuiOutlinedInput-root": {
            ...PAYMENTS_MODAL_STYLES.textField["& .MuiOutlinedInput-root"],
            fontSize: "0.75rem",
            "& .MuiInputBase-input": {
              padding: "6px 4px 6px 8px",
              textAlign: "left",
            },
          },
        }}
        dropdownSx={{
          ...PAYMENTS_MODAL_STYLES.dropdownPaper,
          zIndex: 1400,
          "& .MuiAutocomplete-option": {
            justifyContent: "flex-start",
            textAlign: "left",
          },
        }}
        disablePortal={false}
        disableClearable={true}
      />
      <ResponseModal
        title="Status Update Failed"
        isError={true}
        openBool={showError}
        setOpenBool={setShowError}
        errorMessage={errorMessage}
      />
    </>
  );
}
